export default __webpack_public_path__ + "static/media/problem_tree_legend.1f7fbfd9.svg";